



























import Vue, { PropType } from 'vue'

type Size = 'medium' | 'large'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XDialog',
  props: {
    size: {
      type: String as PropType<Size>,
      default: 'medium',
    },
    clickToClose: {
      type: Boolean,
      default: false,
      // FIXME ダイアログ外をクリックしても閉じない
    },
  },
  computed: {
    hasHeader(): boolean {
      return !!this.$slots.header
    },
    hasActions(): boolean {
      return !!this.$slots.actions
    },
    width(): string {
      switch (this.size) {
        case 'medium':
          return 'max-w-screen-md'
        case 'large':
          return 'max-w-screen-lg'
        default:
          return 'max-w-screen-md'
      }
    },
  },
})
